$(document).ready(function() {
  const removeIds = []

  $('.button-plus').on('click', function() {
    let id = $(this).data("id")
    let value = $(this).data("value")
    let product = $('.product-' + id)
    let totalPrice = $('#total-price')
    product[0].value = +product[0].value + 1
    product[1].value = +product[1].value + 1
    let newTotalPrice = ((+totalPrice.data("value")) + +value)
    totalPrice.data("value", newTotalPrice)
    let formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'VND',
    });
    totalPrice[0].innerText = formatter.format(newTotalPrice)
  })
  $('.button-minus').on('click', function() {
    let id = $(this).data("id")
    let value = $(this).data("value")
    let product = $('.product-' + id)
    let totalPrice = $('#total-price')
    if (product[0].value > 1) {
      product[0].value = +product[0].value - 1
      product[1].value = +product[1].value - 1
      let newTotalPrice = ((totalPrice.data("value")) - value)
      totalPrice.data("value", newTotalPrice)
      let formatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'VND',
      });
      totalPrice[0].innerText = formatter.format(newTotalPrice)
    }
  })
  $('.delete').on('click', function() {
    let id = $(this).data("id")
    let product = $('.cart-product-' + id)
    let countProduct = $('.product-' + id)
    let totalPrice = $('#total-price')
    let newTotalPrice = totalPrice.data("value") - countProduct.data("value") * countProduct[0].value
    totalPrice.data("value", newTotalPrice)
    let formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'VND',
    });
    totalPrice[0].innerText = formatter.format(newTotalPrice)
    removeIds.push(id)
    product.remove()
  })

  $('.save-cart').on('click', function() {
    let data = []
    let products = $('.cart_data')
    products.each(function( index, value ) {
      let cartData = {
        id: $(value).data("id"),
        quantity: $(value).val()
      }
      data.push(cartData)
    })

    $.ajax({
      url: 'carts/update_cart',
      method: 'PUT',
      beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
      data: {
        remove_id: removeIds,
        cart_data: data
      },
      dataType: 'script',
      success: function (response) {
        window.location.reload()
      }
    })
  })

});
